import type { UserRole } from "@/lib/api";

/**
 * 停止ボタンを出してよいか。管理者は誰の実行でも止められ、それ以外は自分が起動したものだけ。
 * 表示の出し分けだけで、実際のゲートはサーバー側 (停止エンドポイントが同じ判定で 403 を返す)。
 * サブエージェントとワークフローで同じ判定を使う — 片方だけ直る事故を避けるため 1 箇所に置く。
 */
export function canStopRun(
	role: UserRole,
	currentUserId: string | null,
	launchedByUserId: string | null,
): boolean {
	if (role === "Admin" || role === "SuperAdmin") return true;
	// 起動者不明 (システム起動) や自分が未ロードのときは出さない。null どうしを一致と見なすと、
	// サーバーが 403 を返す組み合わせに押せるボタンを出すことになる。
	return currentUserId !== null && launchedByUserId === currentUserId;
}
